import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, ManyToOne, JoinColumn } from 'typeorm';
import { IsOptional, IsInt, IsString, IsNotEmpty } from 'class-validator';
import { Paciente } from './Paciente';

@Entity({name: "documentos"})
export class Documento {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsInt()
  paciente_id: number;

  @Column()
  @IsString()
  @IsNotEmpty()
  nome_original: string;

  @Column()
  @IsString()
  @IsNotEmpty()
  documento_aws_key: string;

  @Column()
  @IsString()
  @IsNotEmpty()
  mimetype: string;

  @Column()
  @IsInt()
  tamanho: number;

  @Column()
  @IsString()
  @IsOptional()
  detalhes?: string | null;

  @CreateDateColumn()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @ManyToOne(type => Paciente)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;
}
  